import React from 'react'
import '../App.css'
import VerticalMenu from '../components/VerticalMenu'
import HeaderContent from '../components/HeaderContent'
import HorizontalDashboardMenu from '../components/HorizontalDashboardMenu'
import Time from '../components/Time'

class Vehicle extends React.Component {
  render () {
    let headerTitle = "Aujourd'hui flotte " + localStorage.getItem('fleetName')
    return (
      <div className='App'>
        <table cellSpacing='0' cellPadding='0' style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.colLeft}>
                <VerticalMenu
                  enabled='today'
                />
              </td>
              <td style={styles.content}>
                <HeaderContent
                  title={headerTitle}
                />
                <HorizontalDashboardMenu
                  enabled='vehicle'
                />
              </td>
              <td style={styles.colRight}>
                <Time />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

const styles = {
  table: {
    width: '100%',
    height: '100vh',
    border: 'none'
  },
  colLeft: {
    backgroundColor: '#020202',
    width: '60px',
    verticalAlign: 'top',
    border: 'none'
  },
  content: {
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  colRight: {
    width: '42px',
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  }
}

export default Vehicle
